const PERMISSION_KEY = "personalize:nebula_ultra_transactions";
const PAGE_URL = {
    NEBULA_ULTRA_TRANSACTIONS_PAGE: "/admin/personalize/nebula-ultra-transactions"
};
export { PERMISSION_KEY, PAGE_URL };
